
import { defineComponent, nextTick, reactive, ref, toRefs, watch, computed, ComputedRef, createVNode, getCurrentInstance, onMounted, watchEffect } from 'vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import store from '@/store'
import globalsets from '@/utils/globalsets'
import selectSlider from './selectSlider.vue'
import selectGroup from './selectGroup.vue'
import options, { initResult } from './enumData'
import type { OptionsType, ResultType, Option, SelectNames, ValueType, Item, HistogramType, ResultItemDataType } from './typings'
import { CloseCircleFilled, UpOutlined } from '@ant-design/icons-vue'
import resultItem from './resultitem.vue'
import { handleParams } from './handleParams'
import { message } from 'ant-design-vue'
import type { PropType } from 'vue'
export type pageDataType = {
  getCalendarContainer: any | null
  fundTypeOptions: Option[]
  errTip?: string
  FundType: Array<number>
  activeKey: string[]
  checkAll: boolean
  funddutaion?: HistogramType | undefined
  fundscale?: HistogramType | undefined
  fundratio?: HistogramType | undefined
  fundconcentration?: HistogramType | undefined
  manage?: HistogramType | undefined
  manscale?: HistogramType | undefined
  mannum?: HistogramType | undefined
  optionsProp?: OptionsType
  visible1: boolean
  visible2: boolean
  result: ResultType
  resultIdx: string[]
  groupName: string
  resultItemData?: ComputedRef<ResultItemDataType>
  allDataLength?: ComputedRef<number>
  isEditMode?: boolean
  groupNames?: any
  flag?: boolean
  saveDisabled?: ComputedRef<boolean>
}
export default defineComponent({
  components: { selectSlider, selectGroup, resultItem, CloseCircleFilled, UpOutlined },
  props: {
    theme: {
      type: String,
      default: () => {
        return 'light'
      }
    },
    radiovalue: {
      type: Number,
      default: () => {
        return null
      }
    },
    allData: {
      // 接口返回的所有枚举值
      type: Array,
      default() {
        return []
      }
    },
    editCondIdx: {
      type: Number,
      default: -1
    },
    groups: {
      type: Array as PropType<ResultItemDataType[]>,
      default() {
        return []
      }
    },
    localData: {
      type: Object
    }
  },
  setup(props: any, context) {
    const route = useRoute()
    const ctx = getCurrentInstance()
    const RefFundProfit = ref()
    const RefFundSharp = ref()
    const RefFundDrawBack = ref()
    const RefManProfit = ref()
    const RefManSharp = ref()
    const RefManDrawBack = ref()
    const RefGroupName = ref()
    const pageData: pageDataType = reactive({
      getCalendarContainer: (e: HTMLElement) => e.parentNode,
      checkAll: false,
      fundTypeOptions: [
        { label: '股票型', value: 1, disabled: true },
        { label: '股票指数型', value: 2, disabled: false },
        { label: '混合型', value: 4, disabled: false },
        { label: '债券型', value: 8, disabled: false },
        { label: 'FOF型', value: 16, disabled: false }
      ],
      errTip: '',
      FundType: [1],
      activeKey: ['1', '2'],
      funddutaion: undefined, // 基金年限
      fundscale: undefined, // 基金规模
      fundratio: undefined, // 基金持股比例
      fundconcentration: undefined, // 基金持股集中度
      manage: undefined, // 经理从业年限
      manscale: undefined, // 经理管理基金规模
      mannum: undefined, // 经理管理基金数量
      optionsProp: options,
      visible1: true,
      visible2: false,
      result: initResult,
      resultIdx: ['FundType'],
      groupName: '',
      isEditMode: false, // 编辑模式
      flag: true // 跳转间隙 不触发FundType 的watch true-筛选 false-不筛选
    })
    pageData.saveDisabled = computed(() => { // 除了默认情况，其他都可以保存
      return pageData.resultIdx.length === 1 && pageData.FundType.length === 1 && pageData.FundType[0] === 1
    })
    pageData.resultItemData = computed(() => {
      const res: ResultItemDataType = {
        groupName: pageData.groupName,
        resultIdx: pageData.resultIdx,
        result: { FundType: pageData.FundType, ...pageData.result }
      }
      return res
    })
    // 如果取缓存，是修改模式，校验重名的时候要去掉active name
    watch(
      () => props.editCondIdx,
      (val) => {
        if (val === -1) {
          pageData.isEditMode = false
          pageData.groupName = ''
          return
        }
        pageData.isEditMode = true
        const { resultIdx, groupName, result } = JSON.parse(JSON.stringify(props.groups[val]))
        pageData.FundType = result.FundType
        pageData.result = result
        pageData.groupName = groupName
        pageData.resultIdx = resultIdx
      }
    )
    pageData.groupNames = computed(() => {
      // 获取所有已经存在的name,判断重名
      if (!props.groups || !props.groups.length) return []
      if (pageData.isEditMode) {
        const groupNames = props.groups.map((item: any): string => item.groupName)
        const activeGroupName = props.groups[props.editCondIdx].groupName
        return groupNames.filter((item: string) => item !== activeGroupName)
      } else {
        return props.groups.map((item: any): string => item.groupName)
      }
    })

    const handleHistogram = () => {
      if (!props.allData) return
      const Data = props.allData.filter((item: any) => pageData.FundType.indexOf(item.FundType) > -1)
      pageData.funddutaion = formatData(Data, 'FUNDDURATION')
      pageData.fundscale = formatData(Data, 'FUNDSCALE')
      pageData.fundratio = formatData(Data, 'FUNDRATIO', true)
      pageData.fundconcentration = formatData(Data, 'FUNDCONCENTRATION', true)
      pageData.manage = formatData(Data, 'MANAGE')
      pageData.manscale = formatData(Data, 'MANSCALE')
      pageData.mannum = formatData(Data, 'MANNUM')
    }
    // 把接口返回的多个基金类型的数据加起来
    function formatData(data: any, name: string, isPrecent?: boolean) {
      if (!data || !data.length) {
        return {}
      }
      const Mins = data.map((item: any) => filterName(item, name, 'Min'))
      const Maxs = data.map((item: any) => filterName(item, name, 'Max'))
      const datas = data.map((item: any) => filterName(item, name, 'Data')).flat()
      let max = Math.max.apply(null, Maxs)
      let min = Math.min.apply(null, Mins)
      let sources: number[] = datas.map((i: Item) => i.Val)
      switch (name) {
        case 'FUNDDURATION':
          max = Math.ceil((max / 365) * 100) / 100
          min = Math.floor((min / 365) * 100) / 100

          sources = sources.map((i: number) => {
            const n: any = i / 365
            return parseInt(n)
          })
          break
        case 'FUNDSCALE': // 亿
          max = Math.ceil((max / 100000000) * 100) / 100
          min = Math.floor((min / 100000000) * 100) / 100
          sources = sources.map((i: number) => Math.round(i / 100000000))
          break
        default:
          max = Math.max.apply(null, Maxs)
          max = isPrecent ? max * 100 : max
          max = Math.ceil(max * 100) / 100
          min = Math.min.apply(null, Mins)
          min = isPrecent ? min * 100 : min
          min = Math.floor(min * 100) / 100
          sources = sources.map((i: number) => i * (isPrecent ? 100 : 1))
      }
      compareNewOption(name, max, min)
      return {
        range: [min, max],
        // val: [compareResult[0], compareResult[1]],
        data: sources,
        isPrecent
      }
    }
    // 如果已经存在选中值，切换基金类型时需要和选中值比较，最大值>val[0] 最小值<val[1]
    const names = {
      FUNDDURATION: 'FundDutaion',
      FUNDSCALE: 'FundScale',
      FUNDRATIO: 'FundRatio',
      FUNDCONCENTRATION: 'FundConcentration',
      MANAGE: 'ManAge',
      MANSCALE: 'ManScale',
      MANNUM: 'ManNum'
    }
    function compareNewOption(name: string, max: number, min: number) {
      const result: number[] = [min, max]
      const newName = names[name]
      if (pageData.resultIdx.indexOf(newName) === -1) {
        // 没有选中值，给result加默认结果
        if (pageData.optionsProp && pageData.optionsProp[newName]) {
          pageData.result[newName].select1 = pageData.optionsProp[newName].find((element: Option) => element.value === -1)
        }
        pageData.result[newName].range = result
        pageData.result[newName].max = max
        pageData.result[newName].min = min
        return
      }
      // 当前有选中值，需要判断最大最小值改变之后，选中值是否还在区间中
      const resultRange = pageData.result[newName].range // 如果有range,校验range是否在min-max区间之中
      if (resultRange && resultRange.length) {
        result[0] = resultRange[0] < min || resultRange[0] > max ? min : resultRange[0]
        result[1] = resultRange[0] < min || resultRange[1] > max ? max : resultRange[1]
        pageData.result[newName].range = result
      }
      pageData.result[newName].max = max
      pageData.result[newName].min = min
    }
    function filterName(data: any, name: string, key: string) {
      const temp = data.Histogram.find((i: any) => i.Type === name)
      return temp[key]
    }
    function deleteName(n: string) {
      const idx = pageData.resultIdx.findIndex((name: string) => name === n)
      if (idx > -1) {
        pageData.resultIdx.splice(idx, 1)
      }
    }
    function deleteCondition(name: string) {
      deleteName(name)
      delete pageData.result[name].range
      delete pageData.result[name].select1
      delete pageData.result[name].select2
    }
    function clearCondition(name: string) {
      deleteCondition(name)
      handleParams(pageData.result)
      setLocalStorage()
    }
    function resetConditions(refresh?: boolean) {
      pageData.groupName = ''
      pageData.resultIdx.forEach((item: string) => {
        if (item === 'FundType') {
          pageData.flag = false
          pageData.FundType = [1]
          pageData.result.FundType = pageData.FundType
        } else {
          deleteCondition(item)
        }
      })
      pageData.resultIdx = ['FundType']
      handleHistogram()
      if (refresh) {
        handleParams(pageData.result)
        setLocalStorage()
      }
    }
    function saveGroup() {
      pageData.visible1 = false
      pageData.visible2 = true
      nextTick(() => {
        RefGroupName.value.focus()
      })
    }
    function save() {
      if (!pageData.isEditMode && props.groups.length >= 20) {
        message.error('组合已达上限20')
        return
      }
      const nameReapeatedIdx = (pageData.groupNames || []).findIndex((item: string) => item === pageData.groupName)
      if (nameReapeatedIdx > -1) {
        message.error('已存在相同名称的组合！')
        return
      }
      pageData.visible1 = true
      pageData.visible2 = false
      let result: any = [pageData.resultItemData, ...props.groups]
      if (pageData.isEditMode) {
        result = result.filter((item: any, idx: number) => idx !== props.editCondIdx + 1)
      }
      pageData.isEditMode = false
      const url = 'gw://funccall?funcname=OnWriteFundData;dirName=h5storagespace/conditionstock;fileName=condition.dat;condition=' + encodeURIComponent(JSON.stringify(result))
      window.open(url)
      context.emit('jumpTo', 'save') // 不筛选
      pageData.flag = false
      resetConditions(false)
    }
    function cancel() {
      pageData.visible1 = true
      pageData.visible2 = false
      pageData.groupName = ''
      if (pageData.isEditMode) {
        pageData.isEditMode = false
        resetConditions(false)
        context.emit('jumpTo', 'cancel') // 筛选
      }
    }
    function onCheckAllType(e: any) {
      if (e.target.checked) {
        pageData.FundType = pageData.fundTypeOptions.map((i) => i.value as number)
      } else {
        pageData.FundType = [1]
      }
    }
    function defaultPost() {
      pageData.groupName = ''
      handleParams(pageData.result)
      setLocalStorage()
    }
    function changeVal(val: any, name: SelectNames) {
      pageData.result[name] = {
        ...val,
        label: pageData.result[name].label,
        unit: pageData.result[name].unit,
        max: pageData.result[name].max,
        min: pageData.result[name].min
      }
      if ((val.select1 || {}).value !== -100) {
        deleteName(name)
        pageData.resultIdx.push(name)
      } else {
        // select1为-100时，time是空的，不要将selectGroup中的值渲染到结果中
        deleteName(name)
      }
      handleParams(pageData.result)
      setLocalStorage()
    }
    watch(
      () => pageData.FundType,
      (val) => {
        pageData.checkAll = val.length === pageData.fundTypeOptions.length
        pageData.result.FundType = val
        disabledOnlyOne(val)
        handleHistogram()
        if (pageData.flag && props.radiovalue === 1) {
          handleParams(pageData.result)
          setLocalStorage()
        }
        pageData.flag = true
      }
    )
    function disabledOnlyOne(val) {
      pageData.fundTypeOptions.forEach((item: Option) => {
          item.disabled = false
        })
        if (val.length === 1) {
          const idx = pageData.fundTypeOptions.findIndex((item: Option) => item.value === val[0])
          pageData.fundTypeOptions[idx].disabled = true
        }
    }
    watch(
      () => pageData.fundTypeOptions,
      () => {
        const disabledItem = pageData.fundTypeOptions.filter((item: Option) => item.disabled)
        if (disabledItem.length !== 1) {
          pageData.errTip = ''
        }
      },
      { deep: true }
    )
    onMounted(() => {
      document.querySelector('.item .ant-checkbox-group')?.addEventListener('click', (e: Event) => {
        const targetClass = (e.target as HTMLElement).className
        const disabledNode = document.querySelector('.item .ant-checkbox-wrapper-disabled')
        if ((disabledNode && disabledNode.contains(e.target as Node)) || (targetClass && targetClass.indexOf('ant-checkbox-wrapper-disabled') > -1)) {
          pageData.errTip = '至少选择一个基金类型'
        }
      })
    })
    function setLocalStorage() {
      const params: any = {
        visible1: pageData.visible1,
        visible2: pageData.visible2,
        groupName: pageData.groupName,
        resultIdx: pageData.resultIdx,
        FundType: pageData.FundType,
        result: { ...pageData.result }
      }
      // return params
      context.emit('setLocalStorage', params)
    }
    watch(
      () => props.localData,
      (val) => {
        if (val.noData || !val.resultIdx || !val.resultIdx.length) {
          // 没有缓存
          handleHistogram()
          handleParams(pageData.result)
          return
        }
        // pageData.isEditMode = val.isEditMode
        pageData.visible1 = val.visible1
        pageData.visible2 = val.visible2
        // pageData.groupName = val.groupName
        pageData.resultIdx = val.resultIdx
        pageData.result = val.result
        pageData.FundType = val.FundType
      }
    )
    return {
      ...toRefs(pageData),
      onCheckAllType,
      changeVal,
      resetConditions,
      clearCondition,
      RefFundProfit,
      RefFundSharp,
      RefFundDrawBack,
      RefManProfit,
      RefManSharp,
      RefManDrawBack,
      RefGroupName,
      saveGroup,
      save,
      cancel,
      defaultPost,
      setLocalStorage
    }
  }
})
